module.exports = __webpack_public_path__ + "static/media/9.0904deb0.jpg";